import axios from "axios";
import skapaUtbildningsportratt from "./skapaUtbildningsportratt";

var redigerasida = (function () {
  /* ********** Exponerade funktioner     */
  function initRedigerasida() {
    var blockTypSelectList = document.getElementById("ValdBlocktyp");
    var currentPageIdContainer = document.getElementById("currentPageId");
    
    if (blockTypSelectList) {
      blockTypSelectList.addEventListener("change", function () {
        var blockTyp = blockTypSelectList.options[blockTypSelectList.selectedIndex].value;
        if(!blockTyp) blockTyp = 0;
        selectBlockTyp(blockTyp, currentPageIdContainer.innerHTML);
      });
    
    }
  }

  function selectBlockTyp(selectedValue, currentPageId) {
    PostData(selectedValue, currentPageId).then((result) => {
      if (result && result.status == 200) {
        var skapaBlockFormular = document.getElementById("skapaBlockFormular");
        if (skapaBlockFormular) {
          skapaBlockFormular.innerHTML = result.data;
          skapaBlockFormular.className = "redigerasida-formular";
          skapaUtbildningsportratt.initSkapaUtbildningsportratt();
        }
      }
    });
  }

  function PostData(selectedValue, currentPageId) {
    var response = axios.post(
      "/ubnoy/umucmsapi/redigerasida/valjBlockTyp?valdBlocktyp=" + selectedValue + "&sidId=" + currentPageId
    );
    return response;
  }

  return {
    initRedigerasida: initRedigerasida,
  };
})();

export default redigerasida;
